import { Inject, Injectable } from '@angular/core';
import {
    ConfigRequestsInterface,
    ENDPOINTS,
    EXPANDS,
    InitializableInterface,
    UriUtilitiesService,
    UserMasterInstanceToken,
    UserMasterInterface,
    ConfigInstanceToken,
    ConfigInterface,
} from '@evorait/pace-core';
import { Observable, of } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class ConfigInterfaceService implements ConfigRequestsInterface, InitializableInterface {
    public isInitialized = false;
    public offlineStoreDefiningRequests: string[];

    private readonly commonEndpoints: string[];

    private readonly cseDopSetEndpoint = [ENDPOINTS.CseDopSet];

    private readonly bootStockEndpoint: string[];
    public constructor(
        @Inject(UserMasterInstanceToken) private readonly userMasterService: UserMasterInterface,
        private readonly uriUtilities: UriUtilitiesService,
        @Inject(ConfigInstanceToken) private readonly configService: ConfigInterface,
    ) {
        this.commonEndpoints = [ENDPOINTS.ValueHelpers, ENDPOINTS.ConfigSet, ENDPOINTS.InputFieldProperties];

        this.bootStockEndpoint = [
            this.uriUtilities.appendParameter(ENDPOINTS.MaterialStockSet, EXPANDS.MaterialStockAvailability),
        ];
    }

    /**
     * Initializes configuration parameters that depend on the app id. Since the class is only used statically, there is
     * no new instance created ever and we need to call a static initializer function to fill our definingRequests array.
     *
     * @returns {Observable<string[]>} - An observable that emits the defining requests.
     */
    public init(): Observable<string[]> {
        // The getNotificationHeaderByAppId() thing is not needed anymore, but I kept it in
        // because it worked instantly, but it should be removed globally.
        let notificationsQuery: string = this.uriUtilities.appendParameter(
            ENDPOINTS.NotificationHeaders,
            this.uriUtilities.getNotificationHeaderByAppId(),
        );

        // I think this should be centralized. Most promising with a re-work of uri-utilities.
        // But that would bring additional dependencies in an already un-understable init process.
        const paperworkEnabled = this.configService.getEnableInstallationPaperwork();
        if (paperworkEnabled) {
            notificationsQuery = `${notificationsQuery},${EXPANDS.ExpandEntityPaperwork}`;
        }

        const sourceReplacementEnabled = this.configService.isSourceReplacementEnabled();
        if (sourceReplacementEnabled) {
            notificationsQuery = `${notificationsQuery},${EXPANDS.ExpandEntitySourceReplacement}`;
        }

        // I am 100% sure this is easy to write better.
        this.offlineStoreDefiningRequests = this.commonEndpoints;
        this.offlineStoreDefiningRequests = this.offlineStoreDefiningRequests.concat(notificationsQuery);

        // Seems to be valid for additional use cases. But could that not be done differently?
        const userModel = this.userMasterService.getSelectedUserModel();

        this.offlineStoreDefiningRequests = this.offlineStoreDefiningRequests.concat(this.cseDopSetEndpoint);

        const bootStockEndpointWithFilters = this.uriUtilities.appendFiltersForDefiningRequests(
            this.bootStockEndpoint,
            userModel,
        );
        this.offlineStoreDefiningRequests = this.offlineStoreDefiningRequests.concat(bootStockEndpointWithFilters);

        this.isInitialized = true;

        return of(this.offlineStoreDefiningRequests);
    }
}
